//@flow
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './Reviews.scss';
import one from '../../../../assets/img/flight/landing/reviews/1.png';
import two from '../../../../assets/img/flight/landing/reviews/2.png';
import three from '../../../../assets/img/flight/landing/reviews/3.png';
import four from '../../../../assets/img/flight/landing/reviews/4.png';
import five from '../../../../assets/img/flight/landing/reviews/5.png';
import six from '../../../../assets/img/flight/landing/reviews/6.png';
import seven from '../../../../assets/img/flight/landing/reviews/7.png';
import eight from '../../../../assets/img/flight/landing/reviews/8.png';
import nine from '../../../../assets/img/flight/landing/reviews/9.png';
import ten from '../../../../assets/img/flight/landing/reviews/10.png';
import icons from '../../../../assets/styles/icons.scss';

type Props = {
  index: number;
};

type Review = {
  image: string;
  name: string;
  date: string;
  message: string;
  rating: number;
};

const reviews: Review[] = [
  {
    image: one,
    name: 'Ana Paula',
    date: '28 de Diciembre, 2020',
    message: 'Mi pedido llegó perfecto, muchas gracias!',
    rating: 5,
  },
  {
    image: two,
    name: 'Juan Carlos',
    date: '15 de Noviembre, 2020',
    message: 'La comunicación fue expectacular. Siempre me mantuvo al tanto.',
    rating: 4,
  },
  {
    image: three,
    name: 'Mauro',
    date: '10 de Enero, 2021',
    message: 'Gracias por ayudarme a comprar en USA',
    rating: 5,
  },
  {
    image: four,
    name: 'Ricardo',
    date: '18 de Febrero, 2021',
    message: 'Recibí mi pedido en menos de 15 días.',
    rating: 4,
  },
  {
    image: five,
    name: 'Victoria',
    date: '6 de Marzo, 2021',
    message: 'Pude conseguir lo que buscaba de Estados Unidos.',
    rating: 5,
  },
  {
    image: six,
    name: 'Gabriela',
    date: '2 de Marzo, 2021',
    message: 'La atención fue estupenda.',
    rating: 4,
  },
  {
    image: seven,
    name: 'Antonio',
    date: '23 de Febrero, 2021',
    message: 'La mejor experiencia de compras por internet que he tenido.',
    rating: 5,
  },
  {
    image: eight,
    name: 'Roberto',
    date: '20 de Enero, 2021',
    message: 'Gracias por siempre estar al tanto!',
    rating: 4,
  },
  {
    image: nine,
    name: 'Fernanda',
    date: '20 de Noviembre, 2020',
    message: 'Recibí mis compras extraordinariamente rápido.',
    rating: 4,
  },
  {
    image: ten,
    name: 'Marilia',
    date: '16 de Diciembre, 2020',
    message: 'Siempre estuvo al tanto de mis mensajes y solcitudes.',
    rating: 5,
  },
];


const restrictIndex = (index: number) => index % reviews.length;

export default function Reviews(props: Props) {
  const { index } = props;

  /*const options = {
    infinite: false,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    draggable: true,
    slidesToShow: 1,
  };*/
  
  const buildReview = (review: Review, index: number) => {
    const stars = (
      <div className={style.starsWrap}>
        {(new Array(review.rating)).fill(0).map((_: any, i: number) =>
          <i key={`fill-${i}`}
             className={classNames(icons.iconStarMedium, style.full)}/>)}
        {(new Array(5 - review.rating)).fill(0).map((_: any, i: number) =>
          <i key={`empty-${i}`}
             className={classNames(icons.iconStarMedium, style.empty)}/>)}
      </div>
    );
    
    return (
      <div key={`review-${index}`} className={style.reviewWrap}>
        <div className={style.topWrap}>
          <div className={style.imageWrap}>
            <img src={review.image} alt="customer"/>
          </div>
          <div className={style.contentWrap}>
            <h5>{review.name}</h5>
            <p>{review.date}</p>
            {stars}
          </div>
          <p className={style.comment}>{review.message}</p>
        </div>
      </div>
    )
  };
  
  const chosenReviews = [
    reviews[restrictIndex(index)], 
    reviews[restrictIndex(index + 1)], 
    reviews[restrictIndex(index + 2)]
  ];
  
  const rvs = chosenReviews.map((r, i) => buildReview(r, i));
  
  return (
    <div className={style.reviewsWrap}>
      <h2>Reseñas</h2>
      <div className={style.reviewsContent}>
        {rvs}
        {/*<Slider ref="slick" {...options}>{rvs}</Slider>*/}
        {/*<UntilTablet>
          <section>hola</section>
        </UntilTablet>*/}
      </div>
    </div>
  );
}

Reviews.propTypes = {
  index: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/flight-landing/components/Reviews/Reviews.jsx